import DataTable from "datatables.net-react";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import ReactDOMServer from 'react-dom/server';
import Select from 'react-select';
import { BrokerAgeReportServices } from "../../services/BrokerAgeReportServices";
import * as BullCache from "../../util/BullCache";
import { isMobile } from "../../util/GeneralUtil";
import AdminDropdown from "../components/AdminDropdown";
import BrokerDropdown from '../components/BrokerDropdown';
import ClientDropdown from '../components/ClientDropdown';
import { customStyles, the } from '../components/customStyles';
import From from '../components/From';
import MarketDropdown from '../components/MarketDropdown';
import MasterDropdown from "../components/MasterDropdown";
import NumberFormatter from "../components/NumberFormatter";
import ScriptDropdown from '../components/ScriptDropdown';
import To from '../components/To';
import '../custom.css';

function Brokeragereport() {

  const [loading, setLoading] = useState(false); 
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [selectedBrokerId, setSelectedBrokerId] = useState(null);
  const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [valanDates, setValanDates] = useState([]);
  const [brokerageList, setBrokerageList] = useState([]);
  const [totalBrokerage, setTotalBrokerage] = useState('0');
  const [selectedValan, setSelectedValan] = useState('');
  const [selectedMarket, setSelectedMarket] = useState(null);
  const [selectedScript, setSelectedScript] = useState(null);

  var user = BullCache.getFromCache("user");
  var allScripts = BullCache.getFromCache('allScripts');
  
  const handleSelectedClientChange = (selected) => {
    setSelectedClient(selected?.userId);
  };

  const handleFromDateChange = (newDate) => {
    setFromDate(newDate);
  };

  const handleMarketChange = (market) => {
    setSelectedMarket(market);
  };
  const handleScriptReset = () => {
    setSelectedScript(null);
  };
  const handleScriptChange = (script) => {
    setSelectedScript(script);
  };

  const handleSubmit = () => {
    setLoading(true);

    const dataToSubmit = {
      adminId: user.adminId,
      loginId: user.adminId,
      fromDate: fromDate,
      toDate: toDate,
      valan: selectedValan,
      market: selectedMarket,
      script: selectedScript,
    };

    if (selectedClient) {
      dataToSubmit.userId = selectedClient;
      dataToSubmit.adminId = user.adminId;
    } else if (selectedSubBrokerId) {
      dataToSubmit.adminId = selectedSubBrokerId.value;
    } else if (selectedBrokerId) {
      dataToSubmit.adminId = selectedBrokerId;
    } else if (selectedMaster) {
      dataToSubmit.adminId = selectedMaster.value;
    } else if (selectedAdmin) {
      dataToSubmit.adminId = selectedAdmin.value;
    }
  
    BrokerAgeReportServices.getBrokerage(dataToSubmit).then(res => {
      setLoading(false);

      if (res.code === 1 && (res.data.brokerages.brokerageList)) {
        if (res.data.brokerages.brokerageList.length > 0) {
          setBrokerageList(res.data.brokerages.brokerageList);
          setTotalBrokerage(res.data.brokerages.totalBrokerage);
        }
        else{
          setBrokerageList([]);
          setTotalBrokerage('0');
        }
      }
      else{
        setBrokerageList([]);
        setTotalBrokerage('0');
      }
    });
  };

  const handleReset = () => {
    setSelectedAdmin(null);
    setSelectedMaster(null);
    setSelectedBrokerId(null);
    setSelectedSubBrokerId(null);
    setSelectedClient(null);
    setFromDate('');
    setToDate('');
    setSelectedValan('');
    setSelectedMarket(null);
    setSelectedScript(null);
  };

  const options = valanDates.map(valan => ({
    value: valan.valanId,  
    label: valan.date
  }));

  useEffect(() => {
    BrokerAgeReportServices.valanDates().then(res => {
      if (res.code === 1) {
        if (res.data.valandates.length > 0) {
          setValanDates(res.data.valandates);
        }
      }
    });
    setLoading(true);

    BrokerAgeReportServices.getBrokerage({ adminId: user.adminId, loginId: user.adminId }).then(res => {
    setLoading(false);

      if (res.code === 1  && (res.data.brokerages.brokerageList)) {
        if (res.data.brokerages.brokerageList.length > 0) {
          setBrokerageList(res.data.brokerages.brokerageList);
          setTotalBrokerage(res.data.brokerages.totalBrokerage);
        }
        else{
          setBrokerageList([]);
          setTotalBrokerage('0');
        }
      }
      else{
        setBrokerageList([]);
        setTotalBrokerage('0');
      }
    });

  }, []);

  const handleValanDateChange = (selectedOption) => {
    setSelectedValan(selectedOption ? selectedOption.value : ''); 
  };

  const columns = [
    { title: 'TRADED TIME', data: 'orderTime' , className: "text-nowrap"},
    { title: 'CLIENT', data: 'user', className: "text-nowrap page-wrapper" },
    { title: 'SCRIPT', data: 'script', className: "text-nowrap" },
    { title: 'TRADE TYPE', data: 'orderType', className: "text-nowrap page-wrapper" },
    { title: 'RATE', data: 'rate' },
    { title: 'NET RATE', data: 'netRate' },
    { title: 'QTY', data: 'quantity' },
    { title: 'LOT', data: 'lot' },
    { title: 'MY BROKERAGE', data: 'brokerage',
      render: (data, type, full, meta) =>
        ReactDOMServer.renderToString(<NumberFormatter number={full.brokerage} />),
     },
  ];
 

  return (
    <div className="container-fluid">
      <Card className="mt-2">
        <Card.Body>
          <Row>
            <Col xs={4} sm={2}>
              <b className='fss-05'>MARKET</b>
              <MarketDropdown allScripts={allScripts} onMarketChange={handleMarketChange} onScriptReset={handleScriptReset} />
            </Col>

            <Col xs={4} sm={2}>
              <b className='fss-05'>SCRIPT NAME</b>
              <ScriptDropdown
                allScripts={allScripts}
                selectedMarket={selectedMarket}
                onScriptChange={handleScriptChange}
              />

            </Col>


            <Col xs={4} sm={2} >
              <b style={{ fontSize: 12 }}>VALAN</b>
              <Select
                options={options}        
                value={options.find(option => option.value === selectedValan)} 
                onChange={handleValanDateChange} 
                placeholder="Select"
                styles={customStyles}
                theme={the} 
                isClearable  
                className=" text-black"
            />
            </Col>
            {!isMobile ? (
              <>
                  <Col sm={2} xl={1} xs={6} className="me-1">
                  <b className="fss-05">FROM</b><br />
                  <From fromDate={fromDate} onDateChange={handleFromDateChange} /> {/* Pass props to From component */}
                </Col>

                <Col sm={2} xl={4} xs={5}>
                  <b className="fss-05">TO</b><br />
                  <To toDate={toDate} setToDate={setToDate} />
                </Col>
                </>
            ):""}
  
              {user.adminType === 'SUPER_ADMIN' || user.adminType === 'SUPER_MASTER' ?
              <>
                <Col xs={4} sm={2}>
                  <b className="fss-05" >ADMIN</b>
                  <AdminDropdown
                    adminId={user.adminId}
                    setSelectedOption={setSelectedAdmin} />
                </Col>
              </> : ""}

            {user.adminType === 'SUPER_ADMIN' || user.adminType === 'ADMIN' || user.adminType === 'SUPER_MASTER' ?
              <>
                <Col xs={4} sm={2}>
                  <b className="fss-05">MASTER</b>
                  <MasterDropdown
                    adminId={user.adminId}
                    selectedAdmin={selectedAdmin}
                    setSelectedOption={setSelectedMaster}
                    setSelectedMaster={setSelectedMaster}
                    setSelectedBrokerId={setSelectedBrokerId}
                  />
                </Col>
              </> : ""}


            <Col xs={4} sm={2} >
              <b className="fss-05">CLIENT</b>
              <ClientDropdown
                selectedAdmin={selectedAdmin}
                selectedMaster={selectedMaster}
                selectedBrokerId={selectedBrokerId}
                setSelectedOption={handleSelectedClientChange}
              />

            </Col>

            {isMobile ? (
              <>
                  <Col sm={2} xl={1} xs={6} className="me-3">
                  <b className="fss-05">FROM</b><br />
                  <From fromDate={fromDate} onDateChange={handleFromDateChange} /> {/* Pass props to From component */}
                </Col>

                <Col sm={2} xl={4} xs={4}>
                  <b className="fss-05">TO</b><br />
                  <To toDate={toDate} setToDate={setToDate} />
                </Col>
                </>
            ):""}
            <Col className='mt-4 ' sm={5} xl={4} >
              <div>
                <Button variant="success" className="custom-btn me-2" size="sm" onClick={handleSubmit}>
                  Submit
                </Button> {' '}
                <Button variant="danger" className="custom-btn" size="sm" onClick={handleReset}>
                  Reset
                </Button>
              </div>
            </Col>


          </Row>
        </Card.Body>
      </Card>

      <Card className="mt-2 mb-4">
        <Card.Body>
          <Row>
            <Col style={{ marginLeft: 15 }}>
              <Row>
                <Col xl={6} xs={4} className="text-right"> TOTAL MY BROKERAGE :</Col>
                <Col xl={2} xs={4} className="ps-0 fss-1"> <NumberFormatter number={totalBrokerage}></NumberFormatter></Col>
              </Row>
            </Col>
          </Row>
          <div className="table-responsive">
            {loading ? (
              <div className="container vh-100">
                <div className="d-flex align-items-center justify-content-center h-90">
                  <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
              <DataTable id="table" className="mt-1 table table-striped table-bordered bg-secondary-row fss-08"
                columns={columns} data={brokerageList}
              />
            )}
            </div>
        </Card.Body>
      </Card>
    </div>
  )
}
export default Brokeragereport;